module.exports = __webpack_public_path__ + "img/five1Orange.596a2c08.jpg";